"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackRedeemValueVoucher = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function trackRedeemValueVoucher(voucherCode, voucherValue) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: enums_1.CartEventType.RedeemValueVoucher,
        eventLabel: voucherCode,
        eventData: {
            eventName: enums_1.GA4EventName.AddVoucher,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            voucher_code: voucherCode,
            voucher_value: `${voucherValue.amount} ${voucherValue.currencyCode}`,
        },
    });
}
exports.trackRedeemValueVoucher = trackRedeemValueVoucher;
//# sourceMappingURL=trackCartRedeemValueVoucher.js.map